import React, { useEffect } from "react";
import "./Styles.css";
import AOS from "aos";
import "aos/dist/aos.css";
import img1 from "../assets/1.jpg";
import img2 from "../assets/5.jpg";
import img3 from "../assets/8.jpg";
import img4 from "../assets/1.jpg";
import img5 from "../assets/5.jpg";
import img6 from "../assets/8.jpg";
import img7 from "../assets/1.jpg";
import img8 from "../assets/5.jpg";
import img9 from "../assets/8.jpg";

export default function GallerySection() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const galleryImages = [img1, img2, img3, img4, img5, img6, img7, img8, img9];
  const loopImages = [...galleryImages, ...galleryImages];

  return (
    <section className="gallery-section" data-aos="fade-up">
      <h2 className="gallery-title" data-aos="fade-down">
        Our <span className="highlight">Gallery</span>
      </h2>

      <div className="gallery-carousel">
        <div className="gallery-track">
          {loopImages.map((img, i) => (
            <div
              className="gallery-card"
              key={i}
              data-aos="zoom-in"
              data-aos-delay={i * 100}
            >
              <img src={img} alt={`Gallery ${i + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
